import React from 'react';
import { FilterLink, SelectLinks } from '../../../_lib/components/SelectLinks/SelectLinks';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { translatePageType } from '../../../_lib/components/PageType/PageTypeTitle';
import { PageType } from '../../../types/api/PageType';

export type PageTypesFilter = {
  pageTypes: FilterLink[];
};

export function PageTypesFilter({ pageTypes }: PageTypesFilter) {
  const { t } = useSonTranslation('StructuralPageToPage');

  const mappedLinksWithTranslation = pageTypes?.map(link => ({
    ...link,
    name: link.name === 'all' ? t('filter.all') : translatePageType(link.name as PageType),
  }));
  return (
    mappedLinksWithTranslation && (
      <div className="structural-page-to-page-tree__filters-box">
        <SelectLinks headline={t('filter.pageTypes.headline')} links={mappedLinksWithTranslation} />
      </div>
    )
  );
}
